import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=63ce82f6&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./menu.vue?vue&type=style&index=1&id=63ce82f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce82f6",
  null
  
)

component.options.__file = "menu.vue"
export default component.exports